import React, { useEffect, useMemo, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Box,
  Paper,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"; // ⬅ custom arrow
import { fetchDailySignUpTrend } from "../../../api/nystats";
import { useSelector } from "react-redux";

const iso = (d) => d.toISOString().slice(0, 10);

async function fetchDaily() {
  return Array.from({ length: 24 }, () => Math.round(Math.random() * 1000));
}

export default function DailySignUpTrend() {
  const today = new Date();
  const [dailyDate, setDailyDate] = useState(iso(today));
  const [main, setMain] = useState([]);
  const [prev, setPrev] = useState([]);
  const filter = useSelector((state) => state.filter);
  const [isLoading, setIsLoading] = useState(true);
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter;
    return rest;
  }, [JSON.stringify(filter)]);

  const fetchData =async()=>{
    try {
      setIsLoading(true)
      const { current, previous } = await fetchDailySignUpTrend({
        ...filter,
        date: dailyDate,
      });
      setMain(current);
      setPrev(previous);
    } catch (error) {
      setMain([]);
      setPrev([]);
    }
    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [dailyDate, JSON.stringify(filterWithoutUTM)]);

  // Last 20 days array
  const dateOptions = Array.from({ length: 20 }).map((_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - i);
    return iso(d);
  });

  const cats = Array.from({ length: 24 }, (_, i) => `${i}-${i + 1}`);

  const options = {
    chart: { type: "line", height: 400 },
    xAxis: { categories: cats, },
    yAxis: {
      title: {
        text: "Users",
        style: {
          fontSize: "12px",
          fontWeight: "600",
          color: "#000",
        }
      }
    },
    title: { text: null },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "10px",
            fontWeight: "500",
            textOutline: "none",
            background: '#000',
          }
        }
      }
    },
    series: [
      { name: "Current", data: main, color: "#0D99FF" },
      { name: "Previous", data: prev, dashStyle: "ShortDash", color: "#C4C4C4" }
    ],
    credits: { enabled: false },
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "12px",
        boxShadow: "none",
        border: "1px solid #E8E8E8",
        background: "#fff",
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography fontSize={18} fontWeight={600}>
          Daily Sign-Up Trend
        </Typography>

        {/* ==================== AUTOCOMPLETE ==================== */}
        {(prev?.length || main?.length) && <Autocomplete
          options={dateOptions}
          value={dailyDate}
          onChange={(e, newValue) => setDailyDate(newValue)}
          sx={{ width: 200 }}
          popupIcon={<KeyboardArrowDownIcon />}  // ⬅ Custom right arrow
          renderInput={(params) => (
            <TextField {...params} label="Select Date" />
          )}
        />}
      </Box>

      {
        isLoading ? <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            Loading...
          </Typography>
        </Box> : <>
          <HighchartsReact highcharts={Highcharts} options={options} />
        </>}

    </Paper>
  );
}
